export { TableRow } from './table-row.component'
export type { TableRowProps } from './table-row.types'
